import React, { useState, useEffect } from 'react';
import '../styles/AboutPage.css';
import mountainImg from '../assets/image/mountain_village.png';
import { useTranslation } from 'react-i18next';

function AvatarPlaceholder({ name }) {
  const initials = name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase();
  return (
    <div className="ap-member-avatar">
      <span>{initials}</span>
    </div>
  );
}

function MemberCard({ m }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const displayName = m.prenom ? `${m.prenom} ${m.nom}` : m.nom;
  return (
    <div className="ap-member-card">
      {m.photo_url
        ? <img src={m.photo_url} alt={m.nom} className="ap-member-photo" />
        : <AvatarPlaceholder name={m.nom || 'M'} />
      }
      <h3 className="ap-member-name">{displayName}</h3>
      <span className="ap-member-role">{m.role}</span>
      <div className="ap-member-meta">
        <span>{m.annees_engagement || 0}{t('about.yearsOfEngagement')}</span>
        <span>{m.date_naissance
          ? new Date(m.date_naissance).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
          : t('about.unspecified')
        }</span>
      </div>
      {m.description || m.bio ? (
        <>
          <button className="ap-member-expand-btn" onClick={() => setExpanded(!expanded)}>
            {expanded ? t('about.seeLess') : t('about.seeMore')}
          </button>
          {expanded && <p className="ap-member-description">{m.description || m.bio}</p>}
        </>
      ) : null}
    </div>
  );
}

const FALLBACK_APROPOS = (t) => ({
  definition_terme: t('about.fallbackDef'),
  description: t('about.fallbackDesc'),
  mission: t('about.fallbackMission'),
  date_creation: '22 juillet 1998',
  distance_marrakech: '45 km',
  nb_membres: 20,
  annees_engagement: '+25 ans',
  telephone: '(212) 05 24 48 40 73',
  portable_president: '(212) 066 41 91 08',
  email: 'tiwizi1998@gmail.com',
  site_web: 'http://www.toubkalgiteexpidition.com',
  adresse: 'Douar Taourirt Asni 42152, Al Haouz, Marrakech, Maroc',
});

const objectifs = (t) => [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2C8 2 5 6 5 10c0 5 7 12 7 12s7-7 7-12c0-4-3-8-7-8z" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="10" r="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.obj1Titre'),
    desc: t('about.obj1Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M22 10L12 5L2 10L12 15L22 10Z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 12.5V15.5C6 15.5 8.5 17.5 12 17.5C15.5 17.5 18 15.5 18 15.5V12.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 10V16" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.obj2Titre'),
    desc: t('about.obj2Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.obj3Titre'),
    desc: t('about.obj3Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="9" y1="9" x2="9.01" y2="9" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="15" y1="9" x2="15.01" y2="9" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.obj4Titre'),
    desc: t('about.obj4Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.obj5Titre'),
    desc: t('about.obj5Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2L15 8H21L16 12L18 18L12 14L6 18L8 12L3 8H9L12 2Z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 14V22" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.obj6Titre'),
    desc: t('about.obj6Desc')
  },
];

const giteServices = (t) => [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" strokeLinecap="round" strokeLinejoin="round" />
        <polyline points="9 22 9 12 15 12 15 22" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.gite1Titre'),
    desc: t('about.gite1Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 4h16v16H4z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 4v16M15 4v16M4 9h16M4 15h16" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.gite2Titre'),
    desc: t('about.gite2Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M18 8h1a4 4 0 0 1 0 8h-1" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="6" y1="1" x2="6" y2="4" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="10" y1="1" x2="10" y2="4" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="14" y1="1" x2="14" y2="4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.gite3Titre'),
    desc: t('about.gite3Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M9 18V5l12-2v13" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="6" cy="18" r="3" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="18" cy="16" r="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.gite4Titre'),
    desc: t('about.gite4Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
        <polygon points="10 8 16 12 10 16 10 8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.gite5Titre'),
    desc: t('about.gite5Desc')
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    titre: t('about.gite6Titre'),
    desc: t('about.gite6Desc')
  },
];

function AboutPage() {
  const { t, i18n } = useTranslation();
  const apropos = FALLBACK_APROPOS(t);
  const [membres, setMembres] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const opts = { headers: { 'Accept-Language': i18n.language || 'fr' } };
        const membresRes = await fetch(`${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/members/`, opts);
        if (membresRes.ok) {
          const data = await membresRes.json();
          // Adapter les champs de l'API au format attendu par MemberCard
          const adapted = data.map((m) => ({
            ...m,
            photo_url: m.photo || null,
          }));
          setMembres(adapted);
        }
      } catch (err) {
        console.warn('API indisponible, utilisation des données locales.', err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [i18n.language]);

  return (
    <div className="ap-page">
      {/* Hero */}
      <div className="ap-hero" style={{ backgroundImage: `url(${mountainImg})` }}>
        <div className="ap-hero-overlay" />
        <div className="ap-hero-content">
          <span className="ap-hero-badge">{t('about.since')} {apropos.date_creation?.split(' ').pop() || '1998'}</span>
          <h1 className="ap-hero-title">{t('about.title')} <span className="keyword">Tiwizi</span></h1>
          <p className="ap-hero-sub">{t('about.subtitle')}</p>
        </div>
        <div className="ap-hero-wave">
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="var(--background-solid)" d="M0,100 L0,40 C360,100 1080,0 1440,60 L1440,100 Z" />
          </svg>
        </div>
      </div>

      <div className="ap-container">
        {loading ? (
          <div className="ap-loading"><div className="ap-spinner" /><p>{t('about.loading')}</p></div>
        ) : (
          <>
            {/* ══ 1. PRÉSENTATION ══ */}
            <section className="ap-section">
              <div className="ap-definition">
                <div className="ap-definition-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 16v-4M12 8h.01" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div>
                  <p className="ap-definition-label">{t('about.defTitle')}</p>
                  <p className="ap-definition-text"><strong>TIWIZI</strong> — {apropos.definition_terme || t('about.fallbackDef')}</p>
                </div>
              </div>

              <div className="ap-main-block">
                <div className="ap-text-block">
                  <h2 className="ap-section-title">{t('about.whoIs')}<span className="keyword">Tiwizi</span>{i18n.language === 'ar' ? ' ؟' : ' ?'}</h2>
                  <p>{apropos.description || t('about.fallbackDesc')}</p>
                  <div className="ap-figures">
                    <div className="ap-figure">
                      <span className="ap-figure-val">{apropos.date_creation?.split(' ').pop() || '1998'}</span>
                      <span className="ap-figure-lbl">{t('about.creationYear')}</span>
                    </div>
                    <div className="ap-figure">
                      <span className="ap-figure-val">{apropos.distance_marrakech || '45 km'}</span>
                      <span className="ap-figure-lbl">{t('about.fromMarrakech')}</span>
                    </div>
                    <div className="ap-figure">
                      <span className="ap-figure-val">{apropos.nb_membres || 20}</span>
                      <span className="ap-figure-lbl">{t('about.volunteerMembers')}</span>
                    </div>
                    <div className="ap-figure">
                      <span className="ap-figure-val">{apropos.annees_engagement || '+25 ans'}</span>
                      <span className="ap-figure-lbl">{t('about.engagementYears')}</span>
                    </div>
                  </div>
                </div>

                <div className="ap-location-card">
                  <div className="ap-location-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" strokeLinecap="round" strokeLinejoin="round" />
                      <circle cx="12" cy="10" r="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <h3>{t('about.locationTitle')}</h3>
                  <p>{t('about.locationProv')}</p>
                  <p>{t('about.locationRegion')}</p>
                  <p>{t('about.locationFoot')}</p>
                  {apropos.telephone && <p><strong>{t('about.tel')}</strong> {apropos.telephone}</p>}
                  {apropos.portable_president && <p><strong>{t('about.president')}</strong> {apropos.portable_president}</p>}
                  {apropos.email && <p><a href={`mailto:${apropos.email}`} className="ap-contact-link">{apropos.email}</a></p>}
                  <a href="https://maps.google.com/?q=Asni,Morocco" target="_blank" rel="noopener noreferrer" className="btn-learn-more" style={{ marginTop: '14px' }}>
                    {t('about.mapBtn')}
                  </a>
                </div>
              </div>
            </section>

            <div className="ap-divider" />

            {/* ══ 2. OBJECTIFS & PROJETS ══ */}
            <section className="ap-section">
              <div className="ap-section-header">
                <h2 className="ap-section-title">{t('about.objTitle1')}<span className="keyword">{t('about.objTitleKeyword')}</span>{t('about.objTitle2')}</h2>
                <p className="ap-section-sub">{apropos.mission || t('about.fallbackMission')}</p>
              </div>
              <div className="ap-objectifs-grid">
                {objectifs(t).map((obj, i) => (
                  <div key={i} className="ap-objectif-card">
                    <div className="ap-objectif-icon">{obj.icon}</div>
                    <h3>{obj.titre}</h3>
                    <p>{obj.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <div className="ap-divider" />

            {/* ══ 3. LE GÎTE ══ */}
            <section className="ap-section">
              <div className="ap-section-header">
                <h2 className="ap-section-title">{t('about.giteTitle1')}<span className="keyword">{t('about.giteTitleKeyword')}</span>{t('about.giteTitle2')}</h2>
                <p className="ap-section-sub">
                  {t('about.giteSub')}<strong>1 180 000 DH</strong>.
                </p>
              </div>

              {/* Liste services gîte */}
              <div className="ap-gite-list">
                {giteServices(t).map((s, i) => (
                  <div key={i} className="ap-gite-list-item">
                    <div className="ap-gite-list-icon">{s.icon}</div>
                    <div className="ap-gite-list-content">
                      <span className="ap-gite-list-title">{s.titre}</span>
                      <span className="ap-gite-list-desc">{s.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <div className="ap-divider" />

            {/* ══ 4. MEMBRES ══ */}
            <section className="ap-section">
              <div className="ap-section-header">
                <h2 className="ap-section-title">{t('about.membersTitle1')}<span className="keyword">{t('about.membersTitleKeyword')}</span>{t('about.membersTitle2')}</h2>
              </div>
              <div className="ap-members-wrapper">
                <div className="ap-members-carousel">
                  {membres.map((m) => <MemberCard key={m.id} m={m} />)}
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
}

export default AboutPage;
